import { TaskQueue } from 'js/src/libs/task-queue';

/**
 * Retrieves the global upload network manager.
 * To use the upload network manager, simply use window.uploadNetworkManager
 */
export function getGlobalUploadNetworkManager(): TaskQueue {
    if (!window.uploadNetworkManager || window.uploadNetworkManager.classType !== 'TaskQueue') {
        window.uploadNetworkManager = new TaskQueue(10, 3, [1000, 2000, 4000]);
    }
    return window.uploadNetworkManager;
}

/**
 * Resets the global upload network manager.
 * Primarily for use between tests to ensure that the global upload network manager doesn't pollute tests
 */
export function resetGlobalUploadNetworkManager() {
    if (window.uploadNetworkManager) {
        window.uploadNetworkManager = new TaskQueue(10, 3);
    }
}
